import { render, staticRenderFns } from "./slider-video.vue?vue&type=template&id=080263c9"
import script from "./slider-video.vue?vue&type=script&lang=js"
export * from "./slider-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports